import { makeVar, useReactiveVar } from "@apollo/client";

import { AutocompleteOptionType } from "../models/autocomplete";

export const selectedStatusVariable = makeVar<AutocompleteOptionType | null>(
  null
);

export const useSelectedStatus = () => useReactiveVar(selectedStatusVariable);
